import * as Yup from 'yup';

const intervaloCodigoSchema = Yup.object().shape({
  codIni: Yup.number()
    .typeError('Código inicial inválido')
    .integer('Código inicial inválido')
    .required('Código inicial inválido'),
  codFim: Yup.number()
    .typeError('Código final inválido')
    .integer('Código final inválido')
    .required('Código final inválido'),
});

const intervaloNomeSchema = Yup.object().shape({
  nomeIni: Yup.string().required('Falta Nome Inicial.'),
  nomeFim: Yup.string().required('Falta Nome Final.'),
});

export const baseSchema = Yup.object()
  .shape({
    geId: Yup.number().nullable(),
    grupoGeId: Yup.number().nullable(),
    tipos: Yup.array()
      .of(Yup.string())
      .min(1, 'Nenhum tipo de ativo escolhido!'),
    conversaoMoeda: Yup.boolean(),
    moedaCodigo: Yup.number()
      .nullable()
      .when('conversaoMoeda', {
        is: true,
        then: Yup.number()
          .oneOf([1, 2, 10], 'Moeda inválida')
          .required('Moeda inválida'),
      }),
    cotacoes: Yup.object().when('conversaoMoeda', {
      is: true,
      then: Yup.object().shape({
        usd: Yup.number()
          .moreThan(0, 'Cotação(ões) inválida(s)')
          .required('Cotação(ões) inválida(s)'),
        eur: Yup.number()
          .moreThan(0, 'Cotação(ões) inválida(s)')
          .required('Cotação(ões) inválida(s)'),
        gbp: Yup.number()
          .moreThan(0, 'Cotação(ões) inválida(s)')
          .required('Cotação(ões) inválida(s)'),
      }),
    }),
  })
  .test(
    'escopo-obrigatorio',
    'Escolha um GE ou um grupo de GE',
    ({ geId, grupoGeId }) => !!geId || !!grupoGeId
  );

export const schemaPorQtipo = {
  0: baseSchema,
  1: baseSchema.concat(intervaloCodigoSchema),
  2: baseSchema,
  3: baseSchema.concat(intervaloNomeSchema),
};
